<script setup lang="ts">
import { useInputProductDislikeLink } from '../../../model/additional-info/success/info-success-bad-feedback/input-product-dislike-link.hook'
import { useSelectRelatedTo } from '../../../model/additional-info/success/info-success-bad-feedback/select-related-to.hook'
import { useSelectSource } from '../../../model/additional-info/success/info-success-bad-feedback/select-source.hook'
import ListTaskInfo from '../../task-info/ListTaskInfo.vue'
import RowTaskInfo from '../../task-info/RowTaskInfo.vue'
import InputProductDislikeLink from './info-success-bad-feedback/InputProductDislikeLink.vue'
import SelectRelatedTo from './info-success-bad-feedback/SelectRelatedTo.vue'
import SelectSource from './info-success-bad-feedback/SelectSource.vue'

defineOptions({
  name: 'InfoSuccessBadFeedback',
})

const { isRequired: isRequiredSource } = useSelectSource()
const { isRequired: isRequiredProductDislikeLink } = useInputProductDislikeLink()
const { isRequired: isRequiredRelatedTo } = useSelectRelatedTo()

</script>

<template>
  <ListTaskInfo>
    <RowTaskInfo
      title="Source"
      :required="isRequiredSource"
    >
      <SelectSource />
    </RowTaskInfo>
    <RowTaskInfo
      title="Product dislike link"
      :required="isRequiredProductDislikeLink"
    >
      <InputProductDislikeLink />
    </RowTaskInfo>
    <RowTaskInfo
      title="Related to"
      :required="isRequiredRelatedTo"
    >
      <SelectRelatedTo />
    </RowTaskInfo>
  </ListTaskInfo>
</template>
